import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { ArrowLeftIcon, ChevronDownIcon } from '@systemeio/ui/icons';
import { MenuItemType, SingleItemDropdownInterface, SingleItemHrefInterface } from 'shared/components/header/types/menu-interface';
import { checkNestedIsActive } from 'shared/components/header/utils/check-nested-is-active';
import { checkNestedRendered } from 'shared/components/header/utils/check-nested-rendered';
import { isFlatMenuItem } from 'shared/components/header/utils/is-flat-menu-item';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { twMerge } from 'tailwind-merge';
const DesktopMenuItem = t0 => {
  const $ = _c(2);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = isFlatMenuItem(item) ? <TopMenuItemFlat {...item} /> : <TopMenuDropdown {...item} />;
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default DesktopMenuItem;
function TopMenuItemFlat(item) {
  const $ = _c(7);
  if (!item.shouldRender) {
    return null;
  }
  const isActive = item.isActive(item.href);
  const t0 = isActive ? "border-brand-primary text-background-secondary" : "text-background-tertiary border-transparent";
  let t1;
  if ($[0] !== t0) {
    t1 = twMerge("hover:text-background-secondary hover:border-brand-primary focus-visible:border-brand-primary focus-visible:text-background-secondary flex h-full items-center border-b-4 text-sm font-bold tracking-wide outline-hidden transition-all delay-100", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== item.href || $[3] !== item.name || $[4] !== item.target || $[5] !== t1) {
    t2 = <div className="group relative flex h-full items-center justify-center transition-all"><LinkWithoutPrefetch className={t1} href={item.href} target={item.target}>{item.name}</LinkWithoutPrefetch></div>;
    $[2] = item.href;
    $[3] = item.name;
    $[4] = item.target;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function TopMenuDropdown(item) {
  const $ = _c(11);
  let t0;
  if ($[0] !== item) {
    t0 = checkNestedIsActive(item);
    $[0] = item;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isActive = t0;
  const dropdownItems = item.dropdownItems;
  if (!checkNestedRendered(item.dropdownItems)) {
    return null;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: -5
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== dropdownItems) {
    t2 = <TopMenuDropdownPanel dropdownItems={dropdownItems} />;
    $[3] = dropdownItems;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isActive || $[6] !== item.name) {
    t3 = show => <button className={`main-transition-colors group-hover:text-background-secondary inline-flex h-full items-center border-b-4 text-sm font-bold tracking-wide delay-100 ${isActive || show ? "border-brand-primary text-background-secondary" : "text-background-tertiary border-transparent"} focus:outline-hidden`}>{item.name}<ChevronDownIcon className="ml-2" /></button>;
    $[5] = isActive;
    $[6] = item.name;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Tooltip anchor={t1} stayOnHover={true} mode="hover" popoverClassName="p-0 shadow-lg rounded-lg" wrapperClassName="h-[100%]" label={t2}>{t3}</Tooltip>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function TopSubMenu(item) {
  const $ = _c(11);
  let t0;
  if ($[0] !== item) {
    t0 = checkNestedIsActive(item);
    $[0] = item;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isActive = t0;
  const dropdownItems = item.dropdownItems;
  if (!checkNestedRendered(item.dropdownItems)) {
    return null;
  }
  let t1;
  if ($[2] !== dropdownItems) {
    t1 = <TopMenuDropdownPanel dropdownItems={dropdownItems} />;
    $[2] = dropdownItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      to: "right"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isActive || $[6] !== item.name) {
    t3 = show => <button className={getSubItemClass(isActive || show)}>{item.name}<ArrowLeftIcon className={`group-hover:fill-brand-primary main-transition-colors rotate-180 ${show || isActive ? "fill-brand-primary" : "fill-text-tertiary"}`} /></button>;
    $[5] = isActive;
    $[6] = item.name;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <li><Tooltip stayOnHover={true} mode="hover" popoverClassName="p-0 rounded-lg shadow-lg z-50" wrapperClassName="h-[100%] w-[100%]" className="min-w-[100%]" label={t1} anchor={t2}>{t3}</Tooltip></li>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function TopMenuDropdownPanel(t0) {
  const $ = _c(4);
  const {
    dropdownItems
  } = t0;
  let t1;
  if ($[0] !== dropdownItems) {
    t1 = dropdownItems.map(_temp);
    $[0] = dropdownItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="text-text-tertiary flex flex-col whitespace-nowrap py-4 text-sm">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  if (isFlatMenuItem(item)) {
    return <TopMenuSubItem key={item.name} {...item} />;
  } else {
    return <TopSubMenu key={item.name} {...item} />;
  }
}
export function TopMenuSubItem(item) {
  const $ = _c(12);
  if (!item.shouldRender) {
    return null;
  }
  let T0;
  let t0;
  let t1;
  if ($[0] !== item.dataTestId || $[1] !== item.href || $[2] !== item.isActive) {
    const isActive = item.isActive(item.href);
    T0 = LinkWithoutPrefetch;
    t0 = item.dataTestId;
    t1 = getSubItemClass(isActive);
    $[0] = item.dataTestId;
    $[1] = item.href;
    $[2] = item.isActive;
    $[3] = T0;
    $[4] = t0;
    $[5] = t1;
  } else {
    T0 = $[3];
    t0 = $[4];
    t1 = $[5];
  }
  let t2;
  if ($[6] !== T0 || $[7] !== item.href || $[8] !== item.name || $[9] !== t0 || $[10] !== t1) {
    t2 = <li><T0 data-test-id={t0} className={t1} href={item.href}>{item.name}</T0></li>;
    $[6] = T0;
    $[7] = item.href;
    $[8] = item.name;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
const getSubItemClass = (isActive: boolean) => `flex main-transition-colors ${isActive ? 'text-brand-primary' : 'text-text-tertiary'} px-7 py-1 hover:text-brand-primary focus:outline-hidden focus-visible:text-brand-primary w-full items-center justify-between group`;